/* Shared collection toolbar engine. The shop landing and collection pages
   render the same toolbar (snippets/ppd-collection-toolbar.liquid) and this
   script gives both the same behaviour: filter and sort the cards already on
   the page, newest first by default. Sources come from the page's own list —
   individual pieces never found groups of their own. */
document.querySelectorAll('[data-collection-tools]').forEach(function (tools) {
  var root = tools.closest('[data-tools-root]');
  /** @type {HTMLElement | null} */
  var grid = root
    ? root.querySelector('[data-tools-grid]')
    : document.querySelector('[data-tools-grid]');
  /** @type {HTMLElement | null} */
  var count = root
    ? root.querySelector('[data-tools-count]')
    : document.querySelector('[data-tools-count]');
  if (!grid) return;

  /* A pagination link means the DOM is only one slice of the result set.
     Keep the native pagination honest instead of exposing controls that would
     filter, count, or sort only the current page. */
  var paginationLink = root
    ? root.querySelector('.ppd-pagination a')
    : document.querySelector('.ppd-pagination a');
  if (paginationLink) return;

  /** @type {HTMLElement[]} */
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card--catalog'));
  /** @type {HTMLSelectElement | null} */
  var sourceSelect = tools.querySelector('[data-tools-source]');
  /** @type {HTMLSelectElement | null} */
  var sortSelect = tools.querySelector('[data-tools-sort]');
  var countOne = (count && count.getAttribute('data-count-one')) || '';
  var countOther = (count && count.getAttribute('data-count-other')) || '';
  var countTemplate = count && count.textContent ? count.textContent.trim().replace(/^\d+\s*/, '') : '';

  /**
   * @param {Element} card
   * @returns {string[]}
   */
  function collectionsOf(card) {
    return (card.getAttribute('data-product-collections') || '').trim().split(/\s+/);
  }

  /**
   * @param {Element} card
   * @returns {boolean}
   */
  function matches(card) {
    var wantedSource = sourceSelect ? sourceSelect.value : '';
    if (wantedSource && collectionsOf(card).indexOf(wantedSource) === -1) return false;
    return true;
  }

  /* Keep the complete-set total on the reset option. Named collection options
     intentionally stay uncounted because their memberships can overlap or
     leave products outside the curated source list. */
  function labelTotal() {
    if (!sourceSelect) return;
    var allOption = null;
    Array.prototype.forEach.call(sourceSelect.options, /** @param {HTMLOptionElement} option */ function (option) {
      if (!option.value) allOption = option;
    });
    if (!allOption) return;
    var base = allOption.getAttribute('data-label') || (allOption.textContent ? allOption.textContent.trim().replace(/\s*\(\d+\)$/, '') : '');
    allOption.setAttribute('data-label', base);
    allOption.textContent = base + ' (' + cards.length + ')';
  }

  /**
   * @param {Element[]} list
   * @returns {Element[]}
   */
  function sorted(list) {
    var order = sortSelect ? sortSelect.value : 'newest';
    /**
     * @param {Element} a
     * @param {Element} b
     * @returns {number}
     */
    return list.slice().sort(function (a, b) {
      if (order === 'price-asc' || order === 'price-desc') {
        var delta = Number(a.getAttribute('data-product-price')) - Number(b.getAttribute('data-product-price'));
        return order === 'price-asc' ? delta : -delta;
      }
      if (order === 'title-asc') {
        return (a.getAttribute('data-product-title') || '').localeCompare(b.getAttribute('data-product-title') || '');
      }
      if (order === 'title-desc') {
        return (b.getAttribute('data-product-title') || '').localeCompare(a.getAttribute('data-product-title') || '');
      }
      if (order === 'oldest') {
        return Number(a.getAttribute('data-product-published-at')) - Number(b.getAttribute('data-product-published-at'));
      }
      // 'newest' default
      return Number(b.getAttribute('data-product-published-at')) - Number(a.getAttribute('data-product-published-at'));
    });
  }

  function apply() {
    var visible = sorted(cards.filter(/** @param {Element} card */ function (card) { return matches(card); }));
    cards.forEach(/** @param {HTMLElement} card */ function (card) {
      var shouldShow = matches(card);
      card.hidden = !shouldShow;
      /* Product-card display rules can outrank the browser's default [hidden]
         rule. Own layout removal here so filtered cards cannot remain visible. */
      card.style.display = shouldShow ? '' : 'none';
    });

    var gridEl = /** @type {HTMLElement} */ (grid);
    /* One batched insert: per-card appendChild fires a mutation record each,
       waking the carousel MutationObserver into an O(n^2) rescan during
       100-card re-sorts. Moving through a fragment keeps the same order with
       a single mutation. */
    var fragment = document.createDocumentFragment();
    visible.forEach(/** @param {Element} card */ function (card) { fragment.appendChild(card); });
    gridEl.appendChild(fragment);

    if (count) {
      /* Same grammar as the server render: 0 and 2+ take the plural word,
         exactly 1 takes the singular. Falls back to the server-rendered word
         when the data attributes are absent (e.g. a non-English locale). */
      var word = countTemplate;
      if (countOne && countOther) word = visible.length === 1 ? countOne : countOther;
      count.textContent = visible.length + ' ' + word;
    }
    labelTotal();
  }

  /** @type {HTMLElement} */ (tools).hidden = false;
  tools.addEventListener('change', apply);
  apply();

  // Sticky affordance: subtle border/shadow when pinned below the header.
  (function () {
    var ticking = false;
    function headerOffset() {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--header-group-height');
      var n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
    function updateStuck() {
      if (typeof tools.getBoundingClientRect !== 'function') return;
      var rect = tools.getBoundingClientRect();
      var stuck = rect.top <= headerOffset() + 1 && (window.scrollY || 0) > 8;
      if (tools.classList && typeof tools.classList.toggle === 'function') {
        tools.classList.toggle('is-stuck', stuck);
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateStuck);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // Header height can change after fonts load / resize.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onScroll);
      var header = document.getElementById('header-group') || document.querySelector('[data-header-group]');
      if (header) ro.observe(header);
    }
    updateStuck();
  })();
});
